export default {
  common: {
    getDataFailed: 'Veri alama başarısız',
    cancel: 'İptal',
    noResult: 'sonuç yok',
    prize: 'Ödül',
    totalPrize: 'Toplam ödül',
    round: 'Tur sayısı',
    time: 'zaman',
    address: 'adres',
    options: 'Seçenek',
    type: 'Tip',
    none: 'Yok',
    executedSuccessfully: 'başarıyla çalıştırıldı',
  },
  header: {
    referral: 'Tavsiye et',
    connect: 'Bağlan',
    records: 'Rekorum',
    register: 'Ödeme/Taahhüt',
    disconnect: 'Devamlı bağla',
    networkHint: 'Ağ gecikmenize dikkat edin',
  },
  rules: {
    top: "Mücadeleye hazır mısın? 12 sorumuz var ve bir turda kazananlar 10.000 $'lık ödül havuzundan pay alıyor.",
    title: 'Kurallar',
    section1: "Kayıt 12:00 PM GMT'de kapanır ve etkinlik 12:05 PM GMT'de başlar.",
    section2: "Bu etkinliğe kaydolmak için Lifeform Avatar taahhüt etmeniz ve 1 BUSD ödemeniz gerekir, Lifeform Avatar'ınız yoksa bu etkinliğe kaydolmak için 20 BUSD ödemeniz gerekir.",
    section3: 'Toplam 12 soru bulunmaktadır. Bir soru için 20 saniyeniz cevap seçme hakkınız var ve kalan 5 saniye boyunca doğru cevap açıklanacaktır. Doğru cevap verirseniz bir sonraki soruya geçebilirsiniz.',
    section4: 'Tur bittiğinde bahsi iptal edebilirsiniz.',
    section5: 'Ödüller, her yarışma turundan sonra kazananlara dağıtılacaktır.',
    section6: 'Diriliş kartı almak için arkadaşlarınıza tavsiye bağlantısı gönderin. [Bağlantınızı kullanıp SuperAvatar etkinliğine kaydolduğunda, diriliş kartını alacaksınız]',
    section7: 'Oyuna devam etmek için diriliş kartını kullanabilirsiniz. Her diriliş kartı, tur başına yalnızca bir şans sağlar.',
    section8: 'Kullanılmayan diriliş kartları her turdan sonra otomatik olarak sona erecektir.',
  },
  home: {
    prizePool: 'Ödül havuzu',
    totalParticipants: 'Katılımcı sayısı',
    round: 'Tur sayısı',
    startIn: 'başla',
    connect: 'Bağlan',
    register: 'Kayıt ol',
    registered: 'Kayıtlı',
    enter: 'Gir',
    ongoing: 'İşleniyor',
    ended: 'Bitti',
    cumulativeRanking: 'Kümülatif sıralama',
  },
  register: {
    registerRecords: 'Tescil kadyı',
    registerForRound: 'Kayıt turu sayısı',
    youCanChoose: 'Seçebilirsiniz',
    pay: 'Ödeme',
    or: 'veya',
    stake: 'taahhüdü',
    staked: 'taahhüt edildi',
    paid: 'ödendi',
    inviteFriends: 'Arkadaşları davet etmek',
    insufficientFunds: 'Yetersiz bakiye',
    registerSuccess: 'Kayıt başarısız',
    registerFail: 'Davet Bağlantısı kopyala',
    onceRegistered: 'Kayıt başarılı olduktan sonra, bu Superavata turunun hatıra madalyasını alabilirsiniz.',
    checkMyMedal: 'Hatıra madalyamı kontrol et',
    backToHome: 'Ev sayfasına geri dön.',
  },
  records: {
    myTotalPrize: 'Toplam bonusum',
    myRecordsInSuperAvatar: "Süper Avatar'daki kaydım",
    round: 'Tur sayısı',
    totalRegistered: 'Katılımcı sayısı',
    totalPrize: 'Toplam ödül',
    winners: 'Kazanan',
    defeat: 'Kaybettin',
    myPrize: 'Bonusum',
    myRecordsOfPayStake: 'Ödeme/Taahhüt Kayıdıım',
  },
  share: {
    share: 'Paylaş',
    referralUrlCopied: 'Davet Bağlantısı kopyala',
    showItOff: 'Hava at',
    invitingYouTo: 'Seni davet etti',
    theWinnersTakeAll: 'Kazananlar hepsini paylaşırlar',
    yourReferralUrl: 'Tavsiye Bağlantınız',
    downloadAndShare: 'Resimleri indirin ve paylaşın',
    comeToWin: 'Bonus almak için süper avatara gelin!',
    iHaveDefeated: 'Oyuncuların',
    ofThePlayers: 'ini yendim ve neredeyse',
    isTheWinnerOfThisRound: 'Bu turun galibi',
    hasWon: 'Kazandı',
    comeToTogether: 'Birlikte daha fazla bonus kazanalım',
    hereRecordOf: 'Oyun kaydı burada',
    knowMore: 'Süper Avatar hakkında daha fazla bilgi edinin',
    iHaveWon: 'Kazandım.',
    everyDay: 'her gün',
    resurrectionCardUsed: 'Diriliş kartı kullanıldı',
    everyDay12GMTAAnswer: "Her gün 12:00'de (GMT), 12 soruyu doğru yanıtlayın ve hemen 10000 BUSD'yi eşit olarak paylaşın. Bağlantıya katılın:",
    totalHighAs: 'Toplam ödül',
    everyDay12GMT: "Her gün 12:00'de (GMT)",
    answer12Today1: '12 soruyu doğru cevaplayın, kazananlar günün',
    answer12Today2: 'tüm ödülünü eşit olarak paylaşacak',
    numIHaveDefeated: '',
    numOfThePlayers1: 'oyuncuyu',
    numOfThePlayers2: 'yendim ve neredeyse',
    holdDownShare: 'Paylaşmak için fotoğrafı basılı tutun',
    win: 'kazanç',
  },
  stake: {
    registerByStaking: 'Taahhüt kaydı kullan',
    unstakeAllAvatar: 'unstake all avatar',
    chooseYourAvatar: 'Avatarınızı seçin',
    stake: 'taahhüdü',
    unstake: 'Taahhüdü iptal et',
    unstaked: 'Rehin iptal edildi',
    approveToken: 'Kayıt için şehir adına yetkilendirin',
    approveNFT: 'Amcaya NTF’i rehin için yetkilendirin',
  },
  match: {
    watching: 'İzlemek',
    sorryYouAreOut: 'Üzgünüm, oyunun dışındasın!',
    wishNext: 'Umarım bir sonraki oyunda kazanırsın!',
    totalPrize: 'Toplam ödül',
    survivedAndTotal: 'Hayatta kalma/Katılımcı sayısı',
    prizeForEach: 'Her insan bonus alabilir',
    rememberTo: 'remember to',
    unstakeYourAvatar: 'unstake your avatar',
    congrats: 'Tebrikler!',
    areWinner: 'Bu turun galibi sensin.',
    almostWinner: 'Neredeyse kazananı aradın!',
    keepLearning: 'Bir sonraki turda öğrenmeye devam edin ve kazan!',
    toGetCard: 'Bir sonraki diriliş kartını alın',
  },
  referral: {
    currentRound1: 'Bu yuvarlak',
    currentRound2: 'şimdi',
    inviteYourFriendsTo: 'Arkadaşlarınızı bu diriliş kartı turunu almaya davet edin!',
    referralRecords: 'Önerilen kayıt',
    round: 'Tur sayısı',
    resurrectionCard: 'Diriliş kartı',
    usedOrNot: 'Kullanıyım mı',
    invitedUsers: 'Davet edilen kullanıcılar',
    used: 'Kullanılmış',
    unused: 'Kullanılmayan',
    none: 'Yok',
    viewDetails: 'Ayrıntıları kontrol edin',
  },
};